<header class="top-header glass-card" *ngIf="isAuthenticated">
  <div class="d-flex justify-content-between w-100">
    <!-- Menu toggle -->
    <button class="menu-toggle" (click)="toggleSidebar.emit()">
      <i class="bi bi-list"></i>
    </button>

    <!-- Search box -->
    <!-- <div class="search-box">
      <i class="bi bi-search"></i>
      <input type="text" placeholder="Search Society, User, Registration..." />
      <kbd>⌘K</kbd>U
    </div> -->

    <div class="header-actions d-flex align-items-center">
      <label *ngIf="roles && roles.length > 1" class="role-label">Roles</label>
      <select
        *ngIf="roles && roles.length > 1"
        class="role-select"
        [(ngModel)]="selectedRoleId"
        (change)="selectRole($event)"
      >
        <!-- <option value="">Select Role</option> -->
        <option *ngFor="let r of roles" [value]="r.roleId">
          {{ r.roleName }}
        </option>
      </select>

      <app-navigation></app-navigation>

      <div ngbDropdown class="user-profile" placement="bottom-end">
        <a
          ngbDropdownToggle
          class="d-flex align-items-center gap-2"
          href="javascript:void(0)"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <div class="user-avatar">
            <!-- <img [src]="avatarUrl" alt="User" /> -->
            <img src="{{ imageUrl }}" alt="user" *ngIf="imageUrl" />
            <img
              src="../../../assets/images/users/user4.jpg"
              alt="user"
              *ngIf="!imageUrl"
            />
            <span class="status-dot"></span>
          </div>
          <div class="user-info">
            <span class="user-name" [title]="userName">{{ userName }}</span>
            <!-- <span class="user-role" [title]="roleName">{{ roleName }}</span>  comment by Ranjit ,add with role+yr-->
            <span class="user-role" [title]="displayRoleName">{{
              displayRoleName
            }}</span>
          </div>
          <!-- <i class="bi bi-chevron-down"></i> -->
        </a>
        <div class="dropdown-menu-right" ngbDropdownMenu>
          <a class="dropdown-item" href="/user-profile"
            ><i class="bi bi-person"></i> My Profile</a
          >
          <div class="dropdown-divider"></div>
          <a class="dropdown-item" href="javascript:void(0)" (click)="logOut()"
            ><i class="bi bi-box-arrow-right"></i> Logout</a
          >
        </div>
      </div>
    </div>
  </div>
</header>

<div class="floating-shapes">
  <div class="shape shape-1"></div>
  <div class="shape shape-2"></div>
  <div class="shape shape-3"></div>
</div>

<div class="announcement-bar" *ngIf="!isAuthenticated">
  <div class="container">
    <div class="maintenance-marquee">
      <marquee behavior="scroll" direction="left">
        <!-- 🚀 We’re currently updating the website to serve you better. You can continue using your account and services as usual. We appreciate your patience. -->
        📞 For any technical support-related queries, please contact ✉️
        kunj.tiwari@atishay.com &nbsp;| ✉️ dev.aditya@atishay.com 📞Mob.
        No.-7973719104. &nbsp;&nbsp;|&nbsp; ✉️ For general queries and other
        correspondence, please contact rcs-hp@nic.in or
        rcsofficeshimla@gmail.com
      </marquee>
    </div>
    <div class="announcement-content d-none">
      <div class="left">
        <i class="bi bi-megaphone-fill"></i>
        <span>New: Online Society Registration Portal is now live!</span>
        <a [routerLink]="['/societyRegistration']">
          Learn More <i class="bi bi-arrow-right"></i>
        </a>
      </div>

      <div class="right">
        <i class="bi bi-clock"></i>
        {{ currentDate | date: "dd-MM-yyyy HH:mm:ss" }}
      </div>
    </div>
  </div>
</div>

<header class="main-header" *ngIf="!isAuthenticated">
  <div class="container">
    <nav class="navbar">
      <a href="#" class="brand">
        <div class="emblem" [routerLink]="['/home']" style="cursor: pointer">
          <img src="../../assets/images/logos/hplogo.png" alt="HP Logo" />
        </div>

        <!-- <div class="brand-text">
                    <span class="brand-name">Cooperative Department</span>
                    <span class="brand-sub">Government of Himachal Pradesh</span>
                </div> -->
      </a>
      <!-- 
            <ul class="nav-menu" id="navMenu">
                <li>
                    <a [routerLink]="['/home']" class="active">
                        <i class="fa fa-home"></i> Home
                    </a>
                </li>

                <li>
                    <a [routerLink]="['/aboutus']">
                        <i class="fa fa-info"></i> About Us
                    </a>
                </li>

                <li>
                    <a [routerLink]="['/actrules']">
                        <i class="fa fa-briefcase"></i> Services
                    </a>
                </li>

                <li>
                    <a [routerLink]="['/contact']">
                        <i class="fa fa-phone"></i> Contact
                    </a>
                </li>

                <li>
                    <a routerLink="/calendar">
                        <i class="fa fa-calendar"></i> Calendar
                    </a>
                </li>


            </ul> -->
      <ul class="nav-menu" id="navMenu" *ngIf="!isAuthenticated">
        <!-- Home -->
        <li>
          <a [routerLink]="['/home']" (click)="closeMenu()">
            <i class="fa fa-home"></i> Home
          </a>
        </li>

        <!-- About Department -->
        <li
          class="dropdown"
          [class.open]="isOpen(0)"
          (mouseenter)="setOpen(0)"
          (mouseleave)="closeMenu()"
        >
          <a href="javascript:void(0)">
            <i class="fa fa-info-circle"></i> About Department
          </a>

          <ul class="submenu">
            <li>
              <a
                [routerLink]="['/aboutdepartment/structure']"
                (click)="closeMenu()"
                >Structure</a
              >
            </li>

            <li class="dropdown">
              <a href="javascript:void(0)">Functions</a>
              <ul class="submenu">
                <li>
                  <a
                    [routerLink]="['/aboutdepartment/developmentalfunction']"
                    (click)="closeMenu()"
                  >
                    Developmental Functions
                  </a>
                </li>
                <li>
                  <a
                    [routerLink]="['/aboutdepartment/regulatoryfunction']"
                    (click)="closeMenu()"
                  >
                    Regulatory Functions
                  </a>
                </li>
              </ul>
            </li>

            <li class="dropdown">
              <a href="javascript:void(0)">Budget Allocated</a>
              <ul class="submenu">
                <li>
                  <a
                    [routerLink]="['/aboutdepartment/hodwiseallocation']"
                    (click)="closeMenu()"
                  >
                    Budget Allocation
                  </a>
                </li>
              </ul>
            </li>

            <li class="dropdown">
              <a href="javascript:void(0)">Schemes</a>
              <ul class="submenu">
                <li>
                  <a
                    [routerLink]="['/aboutdepartment/statescheme']"
                    (click)="closeMenu()"
                    >State Schemes</a
                  >
                </li>
                <li>
                  <a
                    [routerLink]="['/aboutdepartment/ncdcschemes']"
                    (click)="closeMenu()"
                    >NCDC Schemes</a
                  >
                </li>
                <li>
                  <a
                    [routerLink]="['/aboutdepartment/icdp']"
                    (click)="closeMenu()"
                    >ICDP</a
                  >
                </li>
                <li>
                  <a
                    [routerLink]="['/aboutdepartment/planexpenditure']"
                    (click)="closeMenu()"
                    >Plan Expenditure</a
                  >
                </li>
                <li>
                  <a
                    [routerLink]="['/aboutdepartment/govtinvestment']"
                    (click)="closeMenu()"
                    >Govt. Investment</a
                  >
                </li>
                <li>
                  <a
                    [routerLink]="['/aboutdepartment/implemented']"
                    (click)="closeMenu()"
                    >Implemented</a
                  >
                </li>
              </ul>
            </li>

            <li>
              <a
                [routerLink]="['/aboutdepartment/telephonedirectory']"
                (click)="closeMenu()"
              >
                Telephone Directory
              </a>
            </li>
          </ul>
        </li>

        <!-- Societies -->
        <li
          class="dropdown"
          [class.open]="isOpen(1)"
          (mouseenter)="setOpen(1)"
          (mouseleave)="closeMenu()"
        >
          <a href="javascript:void(0)">
            <i class="fa fa-building"></i> Societies
          </a>

          <ul class="submenu">
            <li>
              <a href="http://hpscb.com" target="_blank">HP State Coop. Bank</a>
            </li>
            <li><a href="http://hpardb.in" target="_blank">ARDB</a></li>
            <li><a href="http://himfed.com" target="_blank">Himfed</a></li>
            <li>
              <a href="http://www.himbunkar.co.in" target="_blank">Himbunker</a>
            </li>
            <li>
              <a
                href="https://himachal.nic.in/index.php?lang=1&dpt_id=189"
                target="_blank"
                >Woolfed</a
              >
            </li>
            <li>
              <a href="http://hpmilkfed.org" target="_blank">HP Milkfed</a>
            </li>
            <li>
              <a href="http://kccb.in" target="_blank"
                >Kangra Central Coop. Bank</a
              >
            </li>
            <li>
              <a href="http://jccb.co.in" target="_blank"
                >Jogindra Central Coop. Bank</a
              >
            </li>
            <li><a href="http://himcapes.org" target="_blank">Himcapes</a></li>
            <li>
              <a href="/CooperativeSocieties">PACS and Other Societies</a>
            </li>
          </ul>
        </li>

        <!-- Society Registration -->
        <li
          class="dropdown"
          [class.open]="isOpen(2)"
          (mouseenter)="setOpen(2)"
          (mouseleave)="closeMenu()"
        >
          <a href="javascript:void(0)">
            <i class="fa fa-file"></i> Society Registration
          </a>

          <ul class="submenu">
            <li class="dropdown">
              <a href="javascript:void(0)"
                >HP Societies Registration Act 2006
              </a>
              <ul class="submenu">
                <li>
                  <a
                    [routerLink]="['/societyregistration/checklist2006']"
                    (click)="closeMenu()"
                    >Procedure</a
                  >
                </li>
                <li>
                  <a [routerLink]="['/login']" (click)="closeMenu()"
                    >Apply Online</a
                  >
                </li>
                <li>
                  <a
                    [routerLink]="['/societyregistration/charitable-societies']"
                    (click)="closeMenu()"
                    >Search Societies</a
                  >
                </li>
              </ul>
            </li>

            <li class="dropdown">
              <a href="javascript:void(0)"
                >HP Cooperative Societies ACT 1968
              </a>
              <ul class="submenu">
                <li>
                  <a
                    [routerLink]="['/societyregistration/checklist1968']"
                    (click)="closeMenu()"
                    >Procedure</a
                  >
                </li>
                <li>
                  <a [routerLink]="['/login']" (click)="closeMenu()"
                    >Apply Online</a
                  >
                </li>
                <li>
                  <a
                    [routerLink]="[
                      '/societyregistration/cooperative-societies',
                    ]"
                    (click)="closeMenu()"
                    >Search Societies</a
                  >
                </li>
              </ul>
            </li>
          </ul>
        </li>

        <!-- Court Cases -->
        <!-- <li class="dropdown" [class.open]="isOpen(3)" (mouseenter)="setOpen(3)" (mouseleave)="closeMenu()">

                    <a href="javascript:void(0)">
                        <i class="fa fa-gavel"></i> Court Case(s)
                    </a>

                    <ul class="submenu">
                        <li><a [routerLink]="['/courtcases/causelist']" (click)="closeMenu()">Cause List</a></li>
                        <li><a [routerLink]="['/courtcases/searchcases']" (click)="closeMenu()">Search Cases</a></li>
                    </ul>
                </li> -->

        <!-- Audit -->
        <li
          class="dropdown"
          [class.open]="isOpen(4)"
          (mouseenter)="setOpen(4)"
          (mouseleave)="closeMenu()"
        >
          <a href="javascript:void(0)"> <i class="fa fa-check"></i> Audit </a>

          <ul class="submenu">
            <li>
              <a [routerLink]="['/audit/societyauditstatus']"
                >Society Audit Status</a
              >
            </li>
            <li>
              <a [routerLink]="['/audit/approvedauditors']"
                >Approved Panel of Auditors</a
              >
            </li>
          </ul>
        </li>

        <!-- Action Plan -->
        <li
          class="dropdown"
          [class.open]="isOpen(5)"
          (mouseenter)="setOpen(5)"
          (mouseleave)="closeMenu()"
        >
          <a href="javascript:void(0)">
            <i class="fa fa-search"></i> Action Plan
          </a>

          <ul class="submenu">
            <li><a [routerLink]="['/actionplan/audit']">Audit</a></li>
            <li><a [routerLink]="['/actionplan/inspection']">Inspection</a></li>
            <li><a [routerLink]="['/actionplan/enquiry']">Enquiry</a></li>
            <li>
              <a [routerLink]="['/actionplan/arbitration']">Arbitration</a>
            </li>
            <li><a [routerLink]="['/actionplan/appeals']">Appeal</a></li>
            <li>
              <a [routerLink]="['/actionplan/liquidation']">Liquidation</a>
            </li>
            <li>
              <a [routerLink]="['/actionplan/registration']">Registration</a>
            </li>
          </ul>
        </li>

        <!-- RTI -->
        <li
          class="dropdown"
          [class.open]="isOpen(6)"
          (mouseenter)="setOpen(6)"
          (mouseleave)="closeMenu()"
        >
          <a href="javascript:void(0)"> <i class="fa fa-flag"></i> RTI </a>

          <ul class="submenu">
            <li>
              <a [routerLink]="['/rti/publicinformationofficers']"
                >Public Information Officers</a
              >
            </li>
            <li>
              <a [routerLink]="['/rti/dutiesofofficials']"
                >Duties of Officials</a
              >
            </li>
          </ul>
        </li>
      </ul>

      <div class="nav-actions">
        <!-- <button class="lang-toggle">
                    <i class="bi bi-translate"></i>
                    हिंदी
                </button> -->
        <a
          [routerLink]="['/login']"
          *ngIf="!isAuthenticated"
          href="login_design.html"
          class="btn-login"
        >
          <i class="bi bi-person-circle"></i>
          Login
        </a>
        <button class="mobile-toggle" id="mobileToggle">
          <i class="bi bi-list"></i>
        </button>
      </div>
    </nav>
  </div>
</header>
